<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
-->

<gh-ext-page>
  <gh-ext-page-title title="{{'lbl_calendar' | translate}}"></gh-ext-page-title>
  <gh-ext-page-content>
    <div class="calendar" fxLayout="column" fxFlex="1 1 0">
      <div class="calendar-menu" fxLayout="row" fxLayoutAlign="space-between center" fxLayout.lt-md="column-reverse">
        <div class="calendar-menu-nav" fxLayout="row" fxLayoutAlign="start center">
          <a href="javascript:void(0)" class="calendar-menu-nav-link" (click)="nextMonth(false)">{{'lbl_prev' | translate}}</a>
          <a href="javascript:void(0)" class="calendar-menu-nav-link" (click)="currentMonth()">{{'lbl_current' | translate}}</a>
          <a href="javascript:void(0)" class="calendar-menu-nav-link" (click)="nextMonth(true)">{{'lbl_next' | translate}}</a>
        </div>

        <div class="calendar-menu-month" fxFlex="1 1 0">{{ currentMonthName }} {{ currentDate.getFullYear() }}</div>
        <div class="calendar-menu-office" fxLayout="row" fxLayoutAlign="start center" fxShow="" fxHide.lt-md="true">
          <label class="calendar-menu-office-label">{{'lbl_office' | translate}}</label>
          <div fxFlex="" class="m-office-selector">
            <mat-form-field class="ext-main-selector">
              <mat-select placeholder="{{'lbl_office' | translate}}" floatLabel="always" ghCompareBy="id" [value]="currentOffice" (selectionChange)="onCurrentOfficeChange($event.value)">
                <mat-option *ngFor="let office of offices" [value]="office">
                  <ng-container *ngIf="offices.length">{{ office.name }}</ng-container>
                  <ng-container *ngIf="!offices.length">{{'lbl_no_active_offices' | translate}}</ng-container>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="calendar-header" fxLayout="row" fxLayoutAlign="space-around start">
        <div class="calendar-header-item" fxFlex="1 0 auto">
          <span fxShow="" fxHide.lt-md="true">{{'lbl_sunday' | translate}}</span>
          <span fxHide="" fxShow.lt-md="true">{{'lbl_sunday_short' | translate}}</span>
        </div>
        <div class="calendar-header-item" fxFlex="1 0 auto">
          <span fxShow="" fxHide.lt-md="true">{{'lbl_monday' | translate}}</span>
          <span fxHide="" fxShow.lt-md="true">{{'lbl_monday_short' | translate}}</span>
        </div>
        <div class="calendar-header-item" fxFlex="1 0 auto">
          <span fxShow="" fxHide.lt-md="true">{{'lbl_tuesday' | translate}}</span>
          <span fxHide="" fxShow.lt-md="true">{{'lbl_tuesday_short' | translate}}</span>
        </div>
        <div class="calendar-header-item" fxFlex="1 0 auto">
          <span fxShow="" fxHide.lt-md="true">{{'lbl_wednesday' | translate}}</span>
          <span fxHide="" fxShow.lt-md="true">{{'lbl_wednesday_short' | translate}}</span>
        </div>
        <div class="calendar-header-item" fxFlex="1 0 auto">
          <span fxShow="" fxHide.lt-md="true">{{'lbl_thursday' | translate}}</span>
          <span fxHide="" fxShow.lt-md="true">{{'lbl_thursday_short' | translate}}</span>
        </div>
        <div class="calendar-header-item" fxFlex="1 0 auto">
          <span fxShow="" fxHide.lt-md="true">{{'lbl_friday' | translate}}</span>
          <span fxHide="" fxShow.lt-md="true">{{'lbl_friday_short' | translate}}</span>
        </div>
        <div class="calendar-header-item" fxFlex="1 0 auto">
          <span fxShow="" fxHide.lt-md="true">{{'lbl_saturday' | translate}}</span>
          <span fxHide="" fxShow.lt-md="true">{{'lbl_saturday_short' | translate}}</span>
        </div>
      </div>

      <div class="calendar-body" fxFlex="1 1 0">
        <div class="calendar-row" *ngFor="let row of currentDates" [style.min-height.%]="100 / currentDates.length" fxLayout="row">
          <div class="calendar-item" fxLayout="column" [ngClass]="{ 'weekend': isWeekEnd(item), 'before': isDateBefore(item), 'now': isNow(item) }" *ngFor="let item of row">

            <div class="calendar-item-date">
              {{ item.getDate() }}
            </div>

            <div class="calendar-item-orders" fxFlex="auto" fxLayout="column" fxLayoutAlign="end" fxShow="" fxHide.lt-lg="true">
              <div *ngFor="let order of getOrdersByDate(item)" class="calendar-item-order">
                {{ order.purchaseOrder }}
              </div>
            </div>

            <div *ngIf="getOrdersByDate(item).length" class="calendar-item-orders" fxFlex="auto" fxLayout="column" fxLayoutAlign="end" fxHide="" fxShow.lt-lg="true">
              <div class="calendar-item-order" (click)="onOpenOrderInfo(item)">{{ getOrdersByDate(item).length }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </gh-ext-page-content>
</gh-ext-page>
